import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import CheckIcon from '@material-ui/icons/Check'
import Button from '@material-ui/core/Button'

import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'

import Grid from '@material-ui/core/Grid'
//import FormGroup from '@material-ui/core/FormGroup'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import MenuItem from '@material-ui/core/MenuItem'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Switch from '@material-ui/core/Switch'
import Checkbox from '@material-ui/core/Checkbox'

import { handleSaveQuestionAnswer } from '../actions/questions'
import { currencies, buildingStatuses, heatingCosts, powerGeneratorOptions, subleasingOptions, ITCablingCategories, signageCosts, powerGeneratorInfrastructure, securityMeasures, incentives, publicTransport, greenCertificates } from '../utils/_DATA'
import t from '../utils/lang'

const styles = theme => ({
  root: {
    width: '100%',
    borderTop: '1px solid #d9d9d9',
    padding: '15px 0',
    '@media screen and (max-width: 500px)': {
      padding: '10px 0'
    }
  },
  panelRoot: {
    boxShadow: 'none',
    '&:first-child': {
      borderRadius: 0,
      borderTop: 'none'
    }
  },
  panelExpanded: {
    margin: 0,
    borderRadius: 0,
    borderTop: '1px solid #d9d9d9',
    borderBottom: '2px solid #e30613',
  },
  panelExpandedSumbittedProposal: {
    margin: 0,
    borderRadius: 0,
    borderTop: '1px solid #d9d9d9',
  },
  panelQuestion: {
    padding: 0
  },
  panelAnswer: {
    padding: 0
  },
  question: {
    width: 'calc(100% - 24px)',
    fontSize: theme.typography.pxToRem(17),
    /*paddingBottom: '10px',*/
    whiteSpace: 'pre-wrap',
    '@media screen and (max-width: 500px)': {
      fontSize: '0.9rem'
    }
  },
  extraQuestion: {
    width: 'calc(100% - 24px)',
    fontSize: theme.typography.pxToRem(17),
    marginTop: '15px',
    whiteSpace: 'pre-wrap',
    '@media screen and (max-width: 500px)': {
      fontSize: '0.9rem'
    }
  },
  answerHint: {
    fontSize: theme.typography.pxToRem(14),
    fontStyle: 'italic',
    color: '#7b76b6'
  },
  answer: {
    fontSize: theme.typography.pxToRem(14),
    paddingBottom: '20px',
    whiteSpace: 'pre-wrap',
    color: 'rgba(0, 0, 0, 0.7)',
    '@media screen and (max-width: 500px)': {
      fontSize: '0.8rem'
    }
  },
  answerStatus: {
    width: '24px',
    textAling: 'right',
    paddingRight: '0 !important'
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  numberInput: {
    width: '300px',
    '@media screen and (max-width: 500px)': {
      width: '100%',
    }
  },
  numberGridInput: {
    width: '220px',
    marginRight: '20px',
    '@media screen and (max-width: 500px)': {
      marginRight: '10px',
      width: 'calc(50% - 10px)',
    }
  },
  numberObjectInput: {
    width: '220px',
    marginBottom: '10px',
    '@media screen and (max-width: 500px)': {
      width: '100%',
    }
  },
  calendarInput: {
    width: '150px',
    '@media screen and (max-width: 500px)': {
      width: '100%',
    }
  },
  rentInput: {
    width: '120px',
    '@media screen and (max-width: 500px)': {
      width: '100%',
    }
  },
  currencyInput: {
    width: '80px',
    bottom: '16px',
    '@media screen and (max-width: 500px)': {
      width: '100%',
    }
  },
  statusInput: {
    width: '300px',
    '@media screen and (max-width: 500px)': {
      width: '100%',
    }
  },
  socketInput: {
    width: '200px',
    marginRight: '20px',
    '@media screen and (max-width: 500px)': {
      marginRight: '10px',
      width: 'calc(50% - 10px)',
    }
  },
  timeInput: {
    width: '80px',
    marginRight: '20px',
    '@media screen and (max-width: 500px)': {
      marginRight: '10px',
      width: 'calc(50% - 10px)',
    }
  },
  selectInput: {
    width: '300px',
    marginRight: '20px',
    '@media screen and (max-width: 500px)': {
      marginRight: '10px',
      width: 'calc(50% - 10px)',
    }
  },
  certificateSelect: {
    width: '500px',
    marginRight: '20px',
    '@media screen and (max-width: 500px)': {
      marginRight: '10px',
      width: 'calc(50% - 10px)',
    }
  },
  certificateInput: {
    width: '220px',
    marginTop: '16px',
    '@media screen and (max-width: 500px)': {
      marginRight: '10px',
      width: 'calc(50% - 10px)',
    }
  },
  nameInput: {
    width: 'calc(100% - 20px)'
  },
  list: {
    width: '50%',
    '@media screen and (max-width: 500px)': {
      width: '100%',
    }
  },
  listItem: {
    padding: '5px 0'
  },
  checkboxItem: {
    padding: '5px 10px'
  },
  mandatoryIndicator: {
    fontSize: 18,
    color: '#e30613'
  }
});

class Question extends Component {
	state = {
		answerPrimaryField: '',
    answerSecondaryField: '',
    answerThirdField: '',
    snackbarOpen: false,
    expanded: false
	}

  componentDidMount() {
    const { answer, answerFormatId } = this.props.question
    let answerObj = []

    if ([4,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29].includes(answerFormatId) && answer !== '')
      answerObj = JSON.parse(answer)

    if (answerFormatId === 4 && answer !== '') { // currency
      this.setState(() => ({
        answerPrimaryField: answerObj.value,
        answerSecondaryField: answerObj.currency,
      }))

    } else if (answerFormatId === 11 && answer !== '') { // IT sockets
      this.setState(() => ({
        answerPrimaryField: answerObj.rj45,
        answerSecondaryField: answerObj.power,
      }))

    } else if (answerFormatId === 12 || answerFormatId === 29) { // working hours OR typical floor plate
      this.setState(() => ({
        answerPrimaryField: answerObj.from,
        answerSecondaryField: answerObj.to,
      }))

    } else if (answerFormatId === 13 && answer !== '') { // subleasing
      this.setState(() => ({
        answerPrimaryField: answerObj.groupCompany,
        answerSecondaryField: answerObj.thirdParty,
      }))

    } else if (answerFormatId === 14 && answer !== '') { // IT cabling
      this.setState(() => ({
        answerPrimaryField: answerObj.category,
        answerSecondaryField: answerObj.comment,
      }))

    } else if (answerFormatId === 15 && answer !== '') { // signage costs
      this.setState(() => ({
        answerPrimaryField: answerObj.internal,
        answerSecondaryField: answerObj.external,
      }))

    } else if (answerFormatId === 16 && answer !== '') { // landlord - SPV
      this.setState(() => ({
        answerPrimaryField: answerObj.value,
        answerSecondaryField: answerObj.comment,
      }))

    } else if (answerFormatId === 17 && answer !== '') { // landlord and address
      this.setState(() => ({
        answerPrimaryField: answerObj.landlord,
        answerSecondaryField: answerObj.address,
      }))

    } else if (answerFormatId === 18 || answerFormatId === 19) { // power generator infrastucture OR security infrastructure
      this.setState(() => ({
        answerPrimaryField: answerObj ? answerObj : [],
      }))

    } else if (answerFormatId === 20 && answer !== '') { // power generator - tenant's use
      this.setState(() => ({
        answerPrimaryField: answerObj.value,
        answerSecondaryField: answerObj.capacity,
      }))

    } else if (answerFormatId === 21 && answer !== '') { // dual power supply
      this.setState(() => ({
        answerPrimaryField: answerObj.value,
        answerSecondaryField: answerObj.primary,
        answerThirdField: answerObj.secondary,
      }))

    } else if (answerFormatId === 22 && answer !== '') { // hvac system
      this.setState(() => ({
        answerPrimaryField: answerObj.power,
        answerSecondaryField: answerObj.volume,
        answerThirdField: answerObj.density,
      }))

    } else if (answerFormatId === 23 && answer !== '') { // incentives
      this.setState(() => ({
        answerPrimaryField: answerObj.incentives ? answerObj.incentives : [],
        answerSecondaryField: answerObj.period,
      }))

    } else if (answerFormatId === 24 && answer !== '') { // yes or no + company
      this.setState(() => ({
        answerPrimaryField: answerObj.value,
        answerSecondaryField: answerObj.company,
      }))

    } else if (answerFormatId === 25 && answer !== '') { // yes or no + comment
      this.setState(() => ({
        answerPrimaryField: answerObj.value,
        answerSecondaryField: answerObj.comment,
      }))

    } else if (answerFormatId === 26) { // public transport
      this.setState(() => ({
        answerPrimaryField: answerObj ? answerObj : {},
      }))

    } else if (answerFormatId === 27) { // green certificates
      this.setState(() => ({
        answerPrimaryField: answerObj ? answerObj : [],
      }))

    } else if (answerFormatId === 28) { // confirmed or not confirmed + comment
      this.setState(() => ({
        answerPrimaryField: answerObj.value,
        answerSecondaryField: answerObj.comment,
      }))

    } else {
      this.setState(() => ({ answerPrimaryField: answer }))
    }
  }

	handleChangeAnswerPrimaryField = event => {
    this.setState({ answerPrimaryField: event.target.value });
  }

  handleChangeAnswerSecondaryField = event => {
    this.setState({ answerSecondaryField: event.target.value });
  }

  handleChangeAnswerThirdField = event => {
    this.setState({ answerThirdField: event.target.value });
  }

  handleChangeMultipleAnswerPrimary = value => () => {
    const { answerPrimaryField } = this.state
    const currentIndex = answerPrimaryField.indexOf(value)
    const newOptions = [...answerPrimaryField]

    if (currentIndex === -1) {
      newOptions.push(value)
    } else {
      newOptions.splice(currentIndex, 1)
    }

    this.setState({
      answerPrimaryField: newOptions,
    })
  }

  handleChangeObjectAnswerPrimary = (event, id) => {
    const { answerPrimaryField } = this.state
    const publicTransport = {...answerPrimaryField}
    const { value } = event.target

    if (value) {
      publicTransport[id] = event.target.value
    } else {
      delete publicTransport[id]
    }

    this.setState({
      answerPrimaryField: publicTransport,
    })
    //console.log(publicTransport)
  }

  handleSaveAnswer = (event) => {
    const { dispatch, question } = this.props
    const { answerPrimaryField, answerSecondaryField, answerThirdField } = this.state
    let formattedAnswer = answerPrimaryField

    //console.log(id, answer)
    if (question.answerFormatId === 4) { // currency
      formattedAnswer = JSON.stringify({value: answerPrimaryField, currency: answerSecondaryField})
    } else if (question.answerFormatId === 11) { // IT sockets
      formattedAnswer = JSON.stringify({rj45: answerPrimaryField, power: answerSecondaryField})
    } else if (question.answerFormatId === 12 || question.answerFormatId === 29) { // working hours OR typical floor plate
      formattedAnswer = JSON.stringify({from: answerPrimaryField, to: answerSecondaryField})
    } else if (question.answerFormatId === 13) { // subleasing
      formattedAnswer = JSON.stringify({groupCompany: answerPrimaryField, thirdParty: answerSecondaryField})
    } else if (question.answerFormatId === 14) { // IT cabling
      formattedAnswer = JSON.stringify({category: answerPrimaryField, comment: answerSecondaryField})
    } else if (question.answerFormatId === 15) { // signage costs
      formattedAnswer = JSON.stringify({internal: answerPrimaryField, external: answerSecondaryField})
    } else if (question.answerFormatId === 16) { // landlord - SPV
      formattedAnswer = JSON.stringify({value: answerPrimaryField, comment: answerSecondaryField})
    } else if (question.answerFormatId === 17) { // landlord and address
      formattedAnswer = JSON.stringify({landlord: answerPrimaryField, address: answerSecondaryField})
    } else if (question.answerFormatId === 18 || question.answerFormatId === 19) { // power generator OR security infrastructure
      formattedAnswer = (answerPrimaryField.length > 0) ? JSON.stringify(answerPrimaryField) : ''
    } else if (question.answerFormatId === 20) { // power generator
      formattedAnswer = JSON.stringify({value: answerPrimaryField, capacity: answerSecondaryField})
    } else if (question.answerFormatId === 21) { // dual power supply
      formattedAnswer = JSON.stringify({value: answerPrimaryField, primary: answerSecondaryField, secondary: answerThirdField })
    } else if (question.answerFormatId === 22) { // hvac system
      formattedAnswer = JSON.stringify({power: answerPrimaryField, volume: answerSecondaryField, density: answerThirdField })
    } else if (question.answerFormatId === 23) { // incentives
      formattedAnswer = JSON.stringify({period: answerSecondaryField, incentives: answerPrimaryField })
    } else if (question.answerFormatId === 24) { // yes or no + company
      formattedAnswer = JSON.stringify({value: answerPrimaryField, company: answerSecondaryField})
    } else if (question.answerFormatId === 25) { // yes or no + comment
      formattedAnswer = JSON.stringify({value: answerPrimaryField, comment: answerSecondaryField})
    } else if (question.answerFormatId === 26) { // public transport
      formattedAnswer = JSON.stringify(answerPrimaryField)
    } else if (question.answerFormatId === 27) { // green certificates
      formattedAnswer = JSON.stringify(answerPrimaryField)
    } else if (question.answerFormatId === 28) { // confirmed or not confirmed + comment
      formattedAnswer = JSON.stringify({value: answerPrimaryField, comment: answerSecondaryField})
    }
    //console.log(formattedAnswer)

    dispatch(handleSaveQuestionAnswer(question.id, formattedAnswer))

    this.handleOpenSnackbar()
    this.handleTogglePanel()
  }

  handleTogglePanel = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

	render() {
    const { classes, lang, statusId } = this.props
    const { expanded, snackbarOpen, answerPrimaryField, answerSecondaryField, answerThirdField } = this.state
		const { id, question, isMandatory, answerFormatId, hint, enableAttachment, enableComment } = this.props.question
    const proposalSubmitted = statusId === 3 ? true : false

		return (
      <Fragment>
        <ExpansionPanel classes={{ root: classes.panelRoot, expanded: proposalSubmitted ? classes.panelExpandedSumbittedProposal : classes.panelExpanded }} expanded={proposalSubmitted ? true : expanded}>
          <ExpansionPanelSummary className={classes.panelQuestion} onClick={this.handleTogglePanel}>
            <Typography className={classes.question}>
              {question}
              {hint !== '' && (
                <span className={classes.answerHint}>{` (${hint})`}</span>)}
              {Number(isMandatory) ? 
                <span className={classes.mandatoryIndicator}> *</span> : ''}
            </Typography>
            {((typeof answerPrimaryField === 'string' && answerPrimaryField.length > 0) || (typeof answerPrimaryField === 'number' && answerPrimaryField > 0) || (typeof answerPrimaryField === 'object' && Object.keys(answerPrimaryField).length > 0)) && (
              <Typography className={classes.answerStatus}>
                <CheckIcon />
              </Typography>)}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.panelAnswer}>
            {/*<Typography className={classes.answer}>
              {answerPrimaryField === '' ? '–' : answerPrimaryField}
            </Typography>*/}
            <FormControl className={classes.formControl}>
              {answerFormatId === 1 && ( // text
                <TextField
                  id="name[]"
                  value={answerPrimaryField}
                  required={isMandatory}
                  helperText={!answerPrimaryField && 'This field is mandatory.'}
                  multiline
                  placeholder={enableAttachment ? t[lang].attachmentPlaceholder : t[lang].answerPlaceholder}
                  onChange={this.handleChangeAnswerPrimaryField}
                  disabled={proposalSubmitted}
                />)}
              {answerFormatId === 2 && ( // number
                <TextField
                  id="name[]"
                  value={answerPrimaryField}
                  required={isMandatory}
                  helperText={!answerPrimaryField && 'This field is mandatory.'}
                  type="number"
                  placeholder={t[lang].numberPlaceholder}
                  onChange={this.handleChangeAnswerPrimaryField}
                  disabled={proposalSubmitted}
                  className={classes.numberInput}
                />)}
              {answerFormatId === 3 && ( // date
                <TextField
                  id="name[]"
                  value={answerPrimaryField}
                  required={isMandatory}
                  helperText={!answerPrimaryField && 'This field is mandatory.'}
                  type="date"
                  onChange={this.handleChangeAnswerPrimaryField}
                  disabled={proposalSubmitted}
                  className={classes.calendarInput}
                />)}
              {answerFormatId === 4 && ( // currency
                <Grid container spacing={0}>
                  <Grid item>
                    <TextField
                      id="name[]"
                      value={answerPrimaryField}
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      type="number"
                      placeholder={t[lang].rentPlaceholder}
                      onChange={this.handleChangeAnswerPrimaryField}
                      disabled={proposalSubmitted}
                      className={classes.rentInput}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      id="currency[]"
                      select
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      onChange={this.handleChangeAnswerSecondaryField}
                      className={classes.currencyInput}
                      disabled={proposalSubmitted}
                      margin="normal"
                    >
                      {currencies.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>)}
              {answerFormatId === 5 && ( // yes or no
                <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                  <FormControlLabel
                    value="1"
                    control={<Radio color="secondary" disabled={proposalSubmitted} />}
                    label={t[lang].yes}
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio color="default" disabled={proposalSubmitted} />}
                    label={t[lang].no}
                    labelPlacement="end"
                  />
                </RadioGroup>)}
              {answerFormatId === 6 && ( // confirmed or not confirmed
                <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                  <FormControlLabel
                    value="1"
                    control={<Radio color="secondary" disabled={proposalSubmitted} />}
                    label={t[lang].confirmed}
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio color="default" disabled={proposalSubmitted} />}
                    label={t[lang].notConfirmed}
                    labelPlacement="end"
                  />
                </RadioGroup>)}
              {answerFormatId === 7 && ( // freehold or usufruct
                <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                  <FormControlLabel
                    value="1"
                    control={<Radio color="secondary" disabled={proposalSubmitted} />}
                    label={t[lang].freehold}
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio color="secondary" disabled={proposalSubmitted} />}
                    label={t[lang].usufruct}
                    labelPlacement="end"
                  />
                </RadioGroup>)}
              {answerFormatId === 8 && ( // building status
                <TextField
                  id="name[]"
                  select
                  value={answerPrimaryField}
                  required={isMandatory}
                  helperText={!answerPrimaryField && 'This field is mandatory.'}
                  onChange={this.handleChangeAnswerPrimaryField}
                  className={classes.statusInput}
                  disabled={proposalSubmitted}
                  margin="normal"
                >
                  {buildingStatuses[lang].map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>)}
              {answerFormatId === 9 && ( // heating costs
                <TextField
                  id="name[]"
                  select
                  value={answerPrimaryField}
                  required={isMandatory}
                  helperText={!answerPrimaryField && 'This field is mandatory.'}
                  onChange={this.handleChangeAnswerPrimaryField}
                  className={classes.statusInput}
                  disabled={proposalSubmitted}
                  margin="normal"
                >
                  {heatingCosts[lang].map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>)}
              {answerFormatId === 10 && ( // power generator
                <TextField
                  id="name[]"
                  select
                  value={answerPrimaryField}
                  required={isMandatory}
                  helperText={!answerPrimaryField && 'This field is mandatory.'}
                  onChange={this.handleChangeAnswerPrimaryField}
                  className={classes.statusInput}
                  disabled={proposalSubmitted}
                  margin="normal"
                >
                  {powerGeneratorOptions[lang].map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>)}
              {answerFormatId === 11 && ( // IT sockets
                <Grid container>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].rj45Sockets}
                      value={answerPrimaryField}
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      type="number"
                      placeholder={t[lang].rj45Sockets}
                      onChange={this.handleChangeAnswerPrimaryField}
                      disabled={proposalSubmitted}
                      className={classes.socketInput}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].powerSockets}
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      type="number"
                      placeholder={t[lang].powerSockets}
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                      className={classes.socketInput}
                    />
                  </Grid>
                </Grid>)}
              {answerFormatId === 12 && ( // working hours
                <Grid container>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].from}
                      value={answerPrimaryField}
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      type="time"
                      onChange={this.handleChangeAnswerPrimaryField}
                      className={classes.timeInput}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      disabled={proposalSubmitted}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].to}
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      type="time"
                      onChange={this.handleChangeAnswerSecondaryField}
                      className={classes.timeInput}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      disabled={proposalSubmitted}
                    />
                  </Grid>
                </Grid>)}
              {answerFormatId === 13 && ( // subleasing
                <Grid container>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].groupCompany}
                      select
                      value={answerPrimaryField}
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      onChange={this.handleChangeAnswerPrimaryField}
                      className={classes.selectInput}
                      disabled={proposalSubmitted}
                      margin="normal"
                    >
                      {subleasingOptions[lang].map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].thirdParty}
                      select
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                      className={classes.selectInput}
                      margin="normal"
                    >
                      {subleasingOptions[lang].map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>)}
              {answerFormatId === 14 && ( // IT cabling categories
                <Fragment>
                  <TextField
                    id="name[]"
                    select
                    value={answerPrimaryField}
                    required={isMandatory}
                    helperText={!answerPrimaryField && 'This field is mandatory.'}
                    onChange={this.handleChangeAnswerPrimaryField}
                    className={classes.selectInput}
                    disabled={proposalSubmitted}
                    margin="normal"
                  >
                    {ITCablingCategories[lang].map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  {answerPrimaryField === 8 && (<TextField
                    id="name[]"
                    value={answerSecondaryField}
                    required={isMandatory}
                    helperText={!answerSecondaryField && 'This field is mandatory.'}
                    multiline
                    placeholder={t[lang].commentPlaceholder}
                    onChange={this.handleChangeAnswerSecondaryField}
                    disabled={proposalSubmitted}
                  />)}

                </Fragment>)}
              {answerFormatId === 15 && ( // signage costs
                <Grid container>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].internalSignage}
                      select
                      value={answerPrimaryField}
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      onChange={this.handleChangeAnswerPrimaryField}
                      disabled={proposalSubmitted}
                      className={classes.selectInput}
                      margin="normal"
                    >
                      {signageCosts[lang].map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].externalSignage}
                      select
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                      className={classes.selectInput}
                      margin="normal"
                    >
                      {signageCosts[lang].map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>)}
              {answerFormatId === 16 && ( // landlord - SPV
                <Fragment>
                  <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                    <FormControlLabel
                      value="1"
                      control={<Radio color="secondary" disabled={proposalSubmitted} />}
                      label={t[lang].yes}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="default" disabled={proposalSubmitted} />}
                      label={t[lang].no}
                      labelPlacement="end"
                    />
                  </RadioGroup>

                  {answerPrimaryField === "1" && (<Fragment>
                    <Typography className={classes.extraQuestion}>
                      {t[lang].SPVAdditionalQuestion}
                    </Typography>
                    <TextField
                      id="name[]"
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      multiline
                      placeholder={t[lang].answerPlaceholder}
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                    />
                  </Fragment>)}
                </Fragment>)}
              {answerFormatId === 17 && ( // landlord and address
                <Grid container>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="name[]"
                      label={t[lang].landlordPlaceholder}
                      value={answerPrimaryField}
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      placeholder={t[lang].landlordPlaceholder}
                      onChange={this.handleChangeAnswerPrimaryField}
                      disabled={proposalSubmitted}
                      className={classes.nameInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="name[]"
                      label={t[lang].addressPlaceholder}
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      placeholder={t[lang].addressPlaceholder}
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                      className={classes.nameInput}
                    />
                  </Grid>
                </Grid>)}
              {answerFormatId === 18 && ( // power generator infrastucture
                <List className={classes.list}>
                  {powerGeneratorInfrastructure[lang].map(option => (
                    <ListItem key={option.value} className={classes.listItem}>
                      <ListItemText primary={option.label} />
                      <ListItemSecondaryAction>
                        <Switch
                          onChange={this.handleChangeMultipleAnswerPrimary(option.value)}
                          checked={answerPrimaryField.indexOf(option.value) !== -1}
                          value={option.value}
                          disabled={proposalSubmitted}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>)}
              {answerFormatId === 19 && ( // security measures
                <List className={classes.list}>
                  {securityMeasures[lang].map(option => (
                    <ListItem key={option.value} className={classes.listItem}>
                      <ListItemText primary={option.label} />
                      <ListItemSecondaryAction>
                        <Switch
                          onChange={this.handleChangeMultipleAnswerPrimary(option.value)}
                          checked={answerPrimaryField.indexOf(option.value) !== -1}
                          value={option.value}
                          disabled={proposalSubmitted}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>)}
              {answerFormatId === 20 && ( // power generator - tenant's use
                <Fragment>
                  <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                    <FormControlLabel
                      value="1"
                      control={<Radio color="secondary" disabled={proposalSubmitted} />}
                      label={t[lang].yes}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="default" disabled={proposalSubmitted} />}
                      label={t[lang].no}
                      labelPlacement="end"
                    />
                  </RadioGroup>

                  {answerPrimaryField === "1" && (<Fragment>
                    <Typography className={classes.extraQuestion}>
                      {t[lang].powerGeneratorAdditionQuestion}
                    </Typography>
                    <TextField
                      id="name[]"
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      type="number"
                      placeholder={t[lang].capacity}
                      onChange={this.handleChangeAnswerSecondaryField}
                      className={classes.numberInput}
                    />
                  </Fragment>)}
                </Fragment>)}
              {answerFormatId === 21 && ( // dual power supply
                <Fragment>
                  <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                    <FormControlLabel
                      value="1"
                      control={<Radio color="secondary" disabled={proposalSubmitted} />}
                      label={t[lang].yes}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="default" disabled={proposalSubmitted} />}
                      label={t[lang].no}
                      labelPlacement="end"
                    />
                  </RadioGroup>

                  {answerPrimaryField === "1" && (<Fragment>
                    <Typography className={classes.extraQuestion}>
                      {t[lang].dualPowerSupplyAdditionQuestion}
                    </Typography>
                    <Grid container>
                      <Grid item>
                        <TextField
                          id="name[]"
                          label={t[lang].primaryPowerLineLabel}
                          value={answerSecondaryField}
                          required={isMandatory}
                          helperText={!answerSecondaryField && 'This field is mandatory.'}
                          type="number"
                          placeholder={t[lang].primaryPowerLine}
                          onChange={this.handleChangeAnswerSecondaryField}
                          disabled={proposalSubmitted}
                          className={classes.numberGridInput}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          id="name[]"
                          label={t[lang].secondaryPowerLineLabel}
                          value={answerThirdField}
                          required={isMandatory}
                          helperText={!answerThirdField && 'This field is mandatory.'}
                          type="number"
                          placeholder={t[lang].secondaryPowerLine}
                          onChange={this.handleChangeAnswerThirdField}
                          disabled={proposalSubmitted}
                          className={classes.numberGridInput}
                        />
                      </Grid>
                    </Grid>
                  </Fragment>)}
                </Fragment>)}
              {answerFormatId === 22 && ( // hvac system
                <Grid container>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="name[]"
                      label={t[lang].coolingPowerLabel}
                      value={answerPrimaryField}
                      type="number"
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      placeholder={t[lang].coolingPower}
                      onChange={this.handleChangeAnswerPrimaryField}
                      disabled={proposalSubmitted}
                      className={classes.nameInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="name[]"
                      label={t[lang].freshAirVolumeLabel}
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      type="number"
                      placeholder={t[lang].freshAirVolume}
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                      className={classes.nameInput}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="name[]"
                      label={t[lang].workstationsDensityLabel}
                      value={answerThirdField}
                      required={isMandatory}
                      helperText={!answerThirdField && 'This field is mandatory.'}
                      type="number"
                      placeholder={t[lang].workstationsDensity}
                      onChange={this.handleChangeAnswerThirdField}
                      disabled={proposalSubmitted}
                      className={classes.nameInput}
                    />
                  </Grid>
                </Grid>)}
              {answerFormatId === 23 && ( // incentives
                <Fragment>
                  <TextField
                    id="name[]"
                    value={answerSecondaryField}
                    required={isMandatory}
                    helperText={!answerSecondaryField && 'This field is mandatory.'}
                    type="number"
                    placeholder={t[lang].numberPlaceholder}
                    onChange={this.handleChangeAnswerSecondaryField}
                    disabled={proposalSubmitted}
                    className={classes.numberInput}
                  />

                  <Typography className={classes.extraQuestion}>
                    {t[lang].applyingTo}
                  </Typography>
                  <FormGroup>
                    {incentives[lang].map(option => (
                      <FormControlLabel
                        key={option.value}
                        control={<Checkbox
                          checked={answerPrimaryField.indexOf(option.value) !== -1}
                          onChange={this.handleChangeMultipleAnswerPrimary(option.value)}
                          value={option.value}
                          disabled={proposalSubmitted}
                          classes={{ root: classes.checkboxItem }}
                        />}
                        label={option.label}
                      />
                    ))}
                  </FormGroup>
                </Fragment>)}
              {answerFormatId === 24 && ( // yes or no + company
                <Fragment>
                  <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                    <FormControlLabel
                      value="1"
                      control={<Radio color="secondary" disabled={proposalSubmitted} />}
                      label={t[lang].yes}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="default" disabled={proposalSubmitted} />}
                      label={t[lang].no}
                      labelPlacement="end"
                    />
                  </RadioGroup>

                  {answerPrimaryField === "1" && (<Fragment>
                    <TextField
                      id="name[]"
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      multiline
                      placeholder={t[lang].companyPlaceholder}
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                    />
                  </Fragment>)}
                </Fragment>)}
              {answerFormatId === 25 && ( // yes or no + comment
                <Fragment>
                  <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                    <FormControlLabel
                      value="1"
                      control={<Radio color="secondary" disabled={proposalSubmitted} />}
                      label={t[lang].yes}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="default" disabled={proposalSubmitted} />}
                      label={t[lang].no}
                      labelPlacement="end"
                    />
                  </RadioGroup>

                  {answerPrimaryField === "1" && (<TextField
                    id="name[]"
                    value={answerSecondaryField}
                    required={isMandatory}
                    helperText={!answerSecondaryField && 'This field is mandatory.'}
                    multiline
                    placeholder={t[lang].commentPlaceholder}
                    onChange={this.handleChangeAnswerSecondaryField}
                    disabled={proposalSubmitted}
                  />)}
                </Fragment>)}
              {answerFormatId === 26 && ( // public transport
                <Fragment>
                  {publicTransport[lang].map(option => (
                    <TextField
                      id="name[]"
                      key={option.value}
                      label={option.label}
                      value={answerPrimaryField[option.value] ? answerPrimaryField[option.value] : ''}
                      type="number"
                      placeholder={option.label}
                      onChange={(e) => this.handleChangeObjectAnswerPrimary(e, option.value)}
                      disabled={proposalSubmitted}
                      className={classes.numberObjectInput}
                    />
                  ))}
                </Fragment>)}
              {answerFormatId === 27 && ( // green certificates
                <Fragment>
                  {answerPrimaryField.length > 0 && answerPrimaryField.map(certificate => (
                    <Grid container key={certificate.id}>
                      <Grid item>
                        <TextField
                          id="name[]"
                          label={t[lang].certificate}
                          select
                          value={certificate.id}
                          required={isMandatory}
                          helperText={!certificate.id && 'This field is mandatory.'}
                          onChange={this.handleChangeAnswerPrimaryField}
                          disabled={proposalSubmitted}
                          className={classes.certificateSelect}
                          margin="normal"
                        >
                          {greenCertificates[lang].map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item>
                        <TextField
                          id="name[]"
                          label={t[lang].level}
                          value={certificate.level}
                          required={isMandatory}
                          helperText={!certificate.level && 'This field is mandatory.'}
                          placeholder={t[lang].level}
                          onChange={this.handleChangeAnswerSecondaryField}
                          disabled={proposalSubmitted}
                          className={classes.certificateInput}
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Fragment>)}
              {answerFormatId === 28 && ( // confirmed or not confirmed + comment
                <Fragment>
                  <RadioGroup aria-label="position" name="position" value={answerPrimaryField} onChange={this.handleChangeAnswerPrimaryField} row>
                    <FormControlLabel
                      value="1"
                      control={<Radio color="secondary" disabled={proposalSubmitted} />}
                      label={t[lang].confirmed}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="default" disabled={proposalSubmitted} />}
                      label={t[lang].notConfirmed}
                      labelPlacement="end"
                    />
                  </RadioGroup>

                  <TextField
                    id="name[]"
                    value={answerSecondaryField}
                    required={isMandatory}
                    helperText={!answerSecondaryField && 'This field is mandatory.'}
                    multiline
                    placeholder={t[lang].commentPlaceholder}
                    onChange={this.handleChangeAnswerSecondaryField}
                    disabled={proposalSubmitted}
                  />
                </Fragment>)}
              {answerFormatId === 29 && ( // typical floor plate
                <Grid container>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].from}
                      value={answerPrimaryField}
                      required={isMandatory}
                      helperText={!answerPrimaryField && 'This field is mandatory.'}
                      type="number"
                      onChange={this.handleChangeAnswerPrimaryField}
                      disabled={proposalSubmitted}
                      className={classes.numberGridInput}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      id="name[]"
                      label={t[lang].to}
                      value={answerSecondaryField}
                      required={isMandatory}
                      helperText={!answerSecondaryField && 'This field is mandatory.'}
                      type="number"
                      onChange={this.handleChangeAnswerSecondaryField}
                      disabled={proposalSubmitted}
                      className={classes.numberGridInput}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>)}
              {![1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29].includes(answerFormatId) && (
                <TextField
                  id="name[]"
                  value={answerPrimaryField}
                  required={isMandatory}
                  helperText={!answerPrimaryField && 'This field is mandatory.'}
                  multiline
                  placeholder={t[lang].answerPlaceholder}
                  onChange={this.handleChangeAnswerPrimaryField}
                />)}
            </FormControl>
          </ExpansionPanelDetails>
          <ExpansionPanelActions>
            {statusId !== 3 && (
              <Button size="small" color="primary" onClick={event => this.handleSaveAnswer(event)}>
                {t[lang].save}
              </Button>)}
          </ExpansionPanelActions>
        </ExpansionPanel>

        <Snackbar
          open={snackbarOpen}
          onClose={this.handleCloseSnackbar}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{t[lang].answerSaved}</span>}
        />

        {/*<div className={classes.root}>
          <Typography className={classes.question}>
            {question}
          </Typography>
          <Typography className={classes.answer}>
            {answer === '' ? '–' : answer}
          </Typography>
        </div>*/}
      </Fragment>
		)
	}
}

Question.propTypes = {
  question: PropTypes.object.isRequired
}

function mapStateToProps ({ rfpData }) {
  const { lang, statusId } = rfpData

  return {
    lang,
    statusId
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Question))


// WEBPACK FOOTER //
// ./src/components/Question.js